export default {
  list: [],
  modelList: [],
  selected: null,
};
